var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAssistantIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99027 11.7777C8.78656 12.244 8.67162 12.7579 8.66682 13.2981L8.66667 13.3333V18L4 18V14.8889C4 13.1872 5.36452 11.8057 7.05964 11.7782L7.11111 11.7778L8.99027 11.7777ZM14.8889 10.2222C16.6071 10.2222 18 11.6151 18 13.3333V18H9.44444V13.3333C9.44444 11.6151 10.8373 10.2222 12.5556 10.2222H14.8889ZM7.88889 6.33333C9.17533 6.33333 10.2222 7.38022 10.2222 8.66667C10.2222 9.95311 9.17533 11 7.88889 11C6.60244 11 5.55556 9.95311 5.55556 8.66667C5.55556 7.38022 6.60244 6.33333 7.88889 6.33333ZM13.7222 4C15.2233 4 16.4444 5.22111 16.4444 6.72222C16.4444 8.22333 15.2233 9.44444 13.7222 9.44444C12.2211 9.44444 11 8.22333 11 6.72222C11 5.22111 12.2211 4 13.7222 4Z",
    fill: "#242B42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssistantIcon);
export default __webpack_public_path__ + "static/media/assistantIcon.e9591fc56ef1fb8d5cdbaefc08d50a77.svg";
export { ForwardRef as ReactComponent };